import React, { useState, useContext } from 'react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import ChangePasswordModal from './ChangePasswordModal';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [tempToken, setTempToken] = useState(null);
  
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const { username, password } = formData;
  
  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const onSubmit = async e => {
    e.preventDefault();
    setError('');
    
    if (!username || !password) {
      setError('Please fill in all fields');
      return;
    }
    
    setIsLoading(true);
    
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Login failed');
      }
      
      // Check if user needs to change password
      if (data.requirePasswordChange) {
        setTempToken(data.token);
        setShowChangePassword(true);
        setIsLoading(false);
        return;
      }
      
      // Login successful - no password change required
      login(data.token, null);
      toast.success('Login successful!');
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordChanged = () => {
    // Password was changed, complete the login
    setShowChangePassword(false);
    login(tempToken, null);
    toast.success('Password changed! Welcome!');
    navigate('/dashboard');
  };
  
  return (
    <div className="auth-container">
      <Card>
        <Card.Body>
          <Card.Title className="text-center mb-4">Customer Login</Card.Title>
          
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Form onSubmit={onSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your username"
                name="username"
                value={username}
                onChange={onChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your password"
                name="password"
                value={password}
                onChange={onChange}
                required
              />
            </Form.Group>
            
            <Button 
              variant="primary" 
              type="submit" 
              className="w-100"
              disabled={isLoading}
            >
              {isLoading ? 'Logging In...' : 'Login'}
            </Button>
          </Form>
          
          <div className="text-center mt-3">
            <p className="mb-1">
              <Link to="/forgot-password">Forgot Password?</Link>
            </p>
            <p>Are you an admin? <Link to="/admin">Admin Login</Link></p>
          </div>
        </Card.Body>
      </Card>

      {/* Change Password Modal */}
      <ChangePasswordModal
        show={showChangePassword}
        onPasswordChanged={handlePasswordChanged}
        token={tempToken}
      />
    </div>
  );
};

export default Login;
